import { CalendarMode } from './CalendarController.types';

const CALENDAR_SELECTED_MODE_KEY = 'calendarSelectedMode';

export const calendarPanelStorage = {
   setMode: (mode: CalendarMode): void => {
      window.localStorage.setItem(CALENDAR_SELECTED_MODE_KEY, mode);
   },
   getMode: (): CalendarMode | null => {
      const calendarMode = window.localStorage.getItem(CALENDAR_SELECTED_MODE_KEY) as CalendarMode | undefined;
      return calendarMode ?? null;
   },
};
